import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { getImageId } from '@gynzy/gatsby-source-storyblok';
import { compose } from '@/utils/story-composer';

function Figure({ figureCaption, children }) {
	if (figureCaption.length > 0) {
		return (
			<figure className="not-prose">
				<div className="rounded-lg overflow-hidden">{children}</div>
				<figcaption className="md:text-xs 2xl:text-md 3xl:text-xl mt-2 text-slate-grey">{figureCaption}</figcaption>
			</figure>
		);
	}

	return children;
}

const hasSvgExtension = image => image?.split('?')[0]?.match(/\.[0-9a-z]+$/i)[0] === '.svg' || false;

function Image({
	src,
	alt = '',
	title = '',
	figureCaption = '',
	elementProps,
	pageContext = {},
	appearance = '',
	objectFit = 'cover',
	width,
	height,
}) {
	if (!src) {
		return <div {...elementProps} />;
	}

	const imageId = getImageId(src);
	const imageData = pageContext.images?.find(img => img.id === imageId);
	const image = imageData?.localFile?.publicURL || src;
	const isSvg = hasSvgExtension(image);

	if (!imageData || isSvg || !imageData.localFile?.childImageSharp) {
		return (
			<Figure figureCaption={figureCaption}>
				<img
					{...elementProps}
					height={height}
					width={width}
					alt={alt || ''}
					title={title}
					className={appearance}
					src={imageData ? imageData.localFile?.publicURL : src}
					loading="lazy"
				/>
			</Figure>
		);
	}

	return (
		<Figure figureCaption={figureCaption}>
			<GatsbyImage
				{...elementProps}
				image={getImage(imageData.localFile)}
				alt={alt || ''}
				title={title}
				objectFit={objectFit}
				className={appearance}
			/>
		</Figure>
	);
}

export default Image;

const mapBlokToProps = ({ src: { filename = '', title = '', alt = '' }, _uid = '', figureCaption }) => ({
	_uid,
	src: filename,
	title,
	alt,
	figureCaption,
});

compose('image', Image, {
	mapBlokToProps,
});

export const renderAsset = (asset, images) => <Image {...mapBlokToProps({ src: asset })} pageContext={{ images }} />;
